/* eslint-disable @typescript-eslint/no-explicit-any */
import { MultiSelectWithSearchV2 } from "@/components/form-input/array-input-v2/multi-select-with-search-v2";
import { SUPPORTED_DOCUMENT_LIST } from "@/global-data/global-const";

export const SenderEmailForm = ({
  value,
  onChange,
  // dataKey,
  disabled,
}: any) => {
  return (
    <>
      <td className="align-baseline">
        <MultiSelectWithSearchV2
          bindLabel="label"
          bindValue="value"
          placeholder="Supported document types"
          options={SUPPORTED_DOCUMENT_LIST}
          value={value}
          disabled={disabled}
          onChange={onChange}
          // onChange={(prop: any) => {
          //   mutationHandling({
          //     type: "value-update",
          //     payload: {
          //       key: dataKey,
          //       control_name: "supported_doc_types",
          //       value: prop,
          //     },
          //   });
          // }}
          // onBlur={field.onBlur}
          noLimit={true}
        />
      </td>
    </>
  );
};
